
import ownerSchemaLogger from '@wix/bi-logger-events-users';
import visitorSchemaLogger from '@wix/bi-logger-events-uou';

const createBILogger = <TLogger>(
    schemaLogger: (webOrMobileLogger: any) => (userConfig?: any) => TLogger,
) => (factory: any) => (userConfig: any = {}) => {
  return schemaLogger(factory)(userConfig);
}

export const createOwnerBILogger = createBILogger(ownerSchemaLogger);
export const createVisitorBILogger = createBILogger(visitorSchemaLogger);
